export default {
  // Sidebar
  workspaces: 'Workspaces',
  expandChatSidebar: 'Expand chat sidebar',
  collapseChatSidebar: 'Collapse chat sidebar',
  selectWorkspace: 'Select workspace',
  openWorkspaceSettings: 'Open workspace settings',
  createWorkspace: 'Create Workspace',
  agents: 'Agents',
  automations: 'Automations',
  settings: 'Settings',
  chats: 'Chats',
  newChat: 'New chat',
  startNewChat: 'Start a new chat',
  noAccessToWorkspace: 'You do not have access to this workspace.',
  noChatsYet: 'No chats yet.',
  automationChatTooltip: 'Automation: {{title}}',
  draftLabel: 'draft',
  generatingChatTitle: 'Generating chat title',
  generatingReply: 'Generating reply',
  approvalWaiting: 'Waiting for your decision',
  approvalModeLabel: 'Action approval mode',
  approvalModeMenuTitle: 'How should actions be approved?',
  approvalModeAsk: 'Ask for permissions',
  approvalModeAskDescription:
    'Confirmation will be requested when an action cannot be unambiguously authorized from your message.',
  approvalModeApproveForMe: 'Approve for me',
  approvalModeApproveForMeDescription:
    'Every data-changing action in this chat will be approved automatically.',
  approvalModeUpdateFailed: 'Unable to update approval mode',
  approvalAutomaticallyApproved: 'Approved automatically',
  openChatActions: 'Open chat actions',
  chatActionsFor: 'Actions for chat "{{title}}"',
  renameChat: 'Edit',
  renameChatTitle: 'Edit chat title',
  renameChatPlaceholder: 'Enter chat title',
  renameChatSave: 'Save',
  renameChatCancel: 'Cancel',
  renameChatEmpty: 'Enter a chat title.',
  renameChatTooLong: 'Chat title must be at most {{count}} characters.',
  renameChatFailed: 'Unable to rename chat',
  renameChatForbidden: 'You do not have permission to edit this chat title.',
  deleteChatTitle: 'Delete chat "{{title}}"',
  deleteChatConfirm:
    'Are you sure you want to delete this chat? This action cannot be undone.',
  deleteChat: 'Delete chat',
  messagesUsedLabel: 'Messages used',
  messagesQuotaResetNote: 'Resets at the start of next month.',
  workspaceLimitReached: 'Workspace limit reached',
  workspaceCreationUnavailable: 'Workspace creation unavailable',
  workspaceCreationUnavailableDescription:
    'Your current plan or access level does not allow creating another workspace.',

  // Chat shell
  workspaceUnavailable: 'Workspace unavailable',
  chatUnavailable: 'Chat unavailable',
  startFirstChat: 'Start your first chat',
  startFirstChatDescription:
    'Write your first question below to create a private chat in this workspace.',
  selectAChat: 'Select a chat',
  selectAChatDescription:
    'Open a chat from the sidebar or send a new message to create one.',
  writeMessage: 'Ask Laplace anything',
  messageQuotaWarningTitle: 'Monthly message limit almost reached',
  messageQuotaWarningDescription:
    'Messages remaining on the Free plan this month for this workspace: {{count}}.',
  messageQuotaBlockedTitle: 'Monthly message limit reached',
  messageQuotaBlockedDescription:
    'You have used all the messages included in the Free plan for this workspace this month. Upgrade to a paid plan for unlimited messages.',
  messageQuotaBlockedPlaceholder: 'Monthly message limit reached',
  messageQuotaUpgradeCta: 'Upgrade plan',
  trialExpiredPlaceholder: 'Free trial expired. Upgrade to continue.',
  send: 'Send',
  replyGenerationFailed: 'Laplace did not return a reply',
  resendMessage: 'Resend',
  copyMessage: 'Copy',
  copiedMessage: 'Copied',
  messageCopied: 'Copied to clipboard',
  messageCopyFailed: 'Unable to copy message',
  sourceFreshnessTitle: 'Source freshness',
  sourceFreshnessFresh: 'Fresh',
  sourceFreshnessPossiblyStale: 'Possibly stale',
  sourceFreshnessStale: 'Stale',
  sourceFreshnessUnknown: 'Unknown',
  showCode: 'Show Code',
  showDiff: 'Show diff',
  showFiletree: 'Show filetree',
  artifactModalClose: 'Close',
  loadingFileContent: 'Loading file…',
  fileContentError: 'Could not load file content.',
  selectFileToShowCode: 'Select a file to show its code.',
  scrollToBottom: 'Scroll to bottom',
  privateWorkspaceChat: 'Private workspace chat',
  generationStatusPreparing: 'Preparing your request…',
  generationStatusThinking: 'Thinking…',
  generationStatusWriting: 'Writing the reply…',
  generationStatusToolJira: 'Checking Jira…',
  generationStatusToolConfluence: 'Searching Confluence…',
  generationStatusToolGithub: 'Checking GitHub…',
  generationStatusToolMemory: 'Recalling context…',
  generationStatusToolDocs: 'Searching documents…',
  generationStatusToolGmail: 'Sending email…',
  generationStatusToolYandexMail: 'Checking Yandex Mail…',
  generationStatusToolCalendar: 'Checking the calendar…',
  generationStatusToolGeneric: 'Working on your request…',
  thinkingTraceTitle: 'Thinking',
  thinkingTraceExpand: 'Show thinking',
  thinkingTraceCollapse: 'Hide thinking',

  // Empty state
  noWorkspacesYet: 'No workspaces yet',
  noWorkspacesDescription:
    "You're in {{organizationName}}. Create a workspace to get started.",
  noWorkspaceAccess: 'No workspace access',
  noWorkspaceAccessDescription:
    "You're in {{organizationName}}, but you haven't been added to any workspace yet. Ask your organization owner to add you.",
  trialExpiredNoWorkspaceTitle: 'Trial expired',
  trialExpiredNoWorkspaceDescription:
    'Your trial for {{organizationName}} has ended and no workspace was created. Upgrade your plan to create a workspace.',

  // Create stepper
  createWorkspaceTitle: 'Create Workspace',
  createWorkspaceSubtitle: 'Follow the steps to configure your workspace.',
  stepNumber: 'Step {{number}}',
  stepDetails: 'Workspace Details',
  stepPlugins: 'Plugins',
  stepDocuments: 'Documents',
  stepUsers: 'Add users to workspace',
  stepReview: 'Review',
  selectOrganization: 'Select an organization',
  selectOrganizationDescription:
    'Choose an organization from the left sidebar to create a workspace.',
  noWorkspaceAccessStepper: 'No workspace access',
  noWorkspaceAccessStepperDescription:
    'Ask your organization owner or admin to create a workspace for you.',
  workspaceName: 'Workspace name',
  enterWorkspaceName: 'Enter workspace name',
  workspaceDescription: 'Description',
  workspaceDescriptionPlaceholder: 'Optional description for this workspace',
  configureIntegrations: 'Configure integrations for this workspace.',
  jira: 'Jira',
  confluence: 'Confluence',
  gmail: 'Gmail',
  enableJiraIntegration: 'Enable Jira integration for this workspace.',
  enableConfluenceIntegration:
    'Enable Confluence integration for this workspace.',
  enableGmailIntegration: 'Enable shared Gmail integration for this workspace.',
  github: 'GitHub',
  enableGitHubIntegration: 'Enable GitHub integration for this workspace.',
  jiraBaseUrl: 'Jira Cloud URL',
  jiraBaseUrlPlaceholder: 'https://your-company.atlassian.net',
  jiraProject: 'Jira Project',
  jiraProjectPlaceholder: 'Select a Jira project',
  jiraProjectNone: 'Do not select a project',
  defaultProjectLabel: 'Default Project',
  defaultRepoLabel: 'Default Repo',
  defaultResourceNotSet: 'Not Set',
  defaultResourceSet: 'set',
  githubDefaultRepo: 'Default repository',
  githubDefaultRepoPlaceholder: 'Select a repository',
  githubDefaultRepoNone: 'Do not select a repository',
  loadingJiraProjects: 'Loading Jira projects...',
  unableToLoadJiraProjects: 'Unable to load Jira projects.',
  noJiraProjectsAvailable: 'No available Jira projects found.',
  confluenceBaseUrl: 'Confluence Cloud URL',
  confluenceBaseUrlPlaceholder: 'https://your-company.atlassian.net',
  githubScope: 'Repository access',
  githubScopeAllRepositories: 'All repositories of @{{account}}',
  githubScopeSelectedRepositories: 'Selected repositories of @{{account}}',
  githubScopeConfiguredOnGitHub: '(configured on GitHub).',
  githubConfigureOnGitHub: 'Configure on GitHub',
  githubSelectedRepositories: 'Selected repositories',
  loadingGitHubRepositories: 'Loading repositories...',
  unableToLoadGitHubRepositories: 'Unable to load repositories.',
  noGitHubRepositoriesAvailable: 'No repositories granted to the installation.',
  githubSettingsAuthNote:
    'Install the Laplace GitHub App: you will pick the account or organization and the repositories on GitHub.',
  jiraAuthNote:
    'Jira authentication is completed after workspace creation from workspace settings using the "Authenticate with Jira" button. Jira Project can be selected after connection.',
  addUsersDescription: 'Add users who should have access to this workspace.',
  searchUsers: 'Search users by name or email',
  noUsersMatch: 'No users match your search.',
  reviewDescription: 'Review workspace details before creating.',
  workspace: 'Workspace',
  plugins: 'Plugins',
  jiraEnabled: 'Enabled',
  jiraDisabled: 'Disabled',
  oauthNote:
    'OAuth authentication will be completed after the workspace is created.',
  selectedUsers: 'Selected users ({{count}})',
  selectedUsersTitle: 'Users',
  selectedUsersCount: 'Selected: {{number}}',
  documentsAddedCount: 'Added: {{number}}',
  selectedUsersDescription: 'Users that will be added to this workspace.',
  noUsersSelected: 'No users selected.',
  noPluginsConnected: 'No plugins connected.',

  // Workspace settings
  workspaceNotFound: 'Workspace not found',
  accessDenied: 'Access denied',
  accessDeniedDescription: 'You are not allowed to access this workspace.',
  settingsTitle: 'Settings — {{name}}',
  settingsDescription: 'Manage workspace configuration and members.',
  deleteWorkspace: 'Delete workspace',
  leaveWorkspace: 'Leave workspace',
  general: 'General',
  members: 'Members',
  enableJiraPlugin: 'Enable Jira plugin',
  jiraAuthDescription:
    'Workspace admin authenticates once through Atlassian OAuth. Everyone in this workspace then uses the shared Jira connection.',
  jiraSecurityNote:
    'Create a Jira user named "Laplace" and grant it only the permissions Laplace needs: "Browse projects" and "Add comments". Then start authentication and sign in to Jira with that user.',
  jiraAuthentication: 'Jira authentication',
  confluenceAuthentication: 'Confluence authentication',
  jiraStatus: 'Status: {{status}}',
  confluenceStatus: 'Status: {{status}}',
  gmailStatus: 'Status: {{status}}',
  loadingJiraStatus: 'Loading Jira connection status...',
  jiraStatusError: 'Unable to load Jira connection status.',
  connectedSite: 'Connected site',
  notConnected: 'Not connected',
  connectedAccount: 'Connected account',
  connectedAccounts: 'Connected accounts',
  integrationPermissions: 'What the integration can do',
  atlassianScopesDisclaimer:
    'These permissions define operation types available to the app. Actual data access is still limited by the connected Atlassian account permissions.',
  gmailScopesDisclaimer:
    'These permissions were granted by Google OAuth for the connected shared mailbox.',
  yandexMailScopesDisclaimer:
    'These permissions were granted by Yandex OAuth for the connected shared mailbox.',
  githubPermissionsDisclaimer:
    'The GitHub App is limited to the selected account and repositories. Exact app permissions are configured in GitHub.',
  noReportedScopes: 'No permissions reported.',
  scopeGroupRead: 'Read',
  scopeGroupWrite: 'Write',
  scopeGroupManage: 'Manage',
  scopeGroupProfile: 'Profile',
  scopeGroupMail: 'Mail',
  scopeGroupOther: 'Other',
  reconnectJira: 'Reconnect Jira',
  reconnectConfluence: 'Reconnect Confluence',
  authenticateWithJira: 'Authenticate with Jira',
  authenticateWithConfluence: 'Authenticate with Confluence',
  authenticateWithGmail: 'Authenticate with Gmail',
  reconnectGmail: 'Reconnect Gmail',
  connectAnotherGmailAccount: 'Connect another Gmail account',
  gmailDraftPermissionRequired:
    'Reconnect Gmail to grant permission to create drafts. Sending remains available until then.',
  disconnect: 'Disconnect',
  enabledPlugins: 'Enabled plugins',
  noPluginsEnabled: 'No plugins enabled.',
  memberCount_one: '{{count}} member',
  memberCount_other: '{{count}} members',
  noMembersListed: 'No members listed.',
  owner: 'owner',
  admin: 'admin',
  member: 'member',
  deleteWorkspaceConfirmTitle: 'Delete workspace',
  deleteWorkspaceConfirmDescription:
    'Are you sure you want to delete this workspace? This action cannot be undone. All workspace data will be deleted.',
  deleteWorkspaceConfirm:
    'Are you sure you want to delete this workspace? This action cannot be undone. All workspace data will be deleted.',
  leaveWorkspaceConfirmTitle: 'Leave workspace',
  leaveWorkspaceConfirmDescription:
    'Are you sure you want to leave this workspace? Your data in this workspace will be deleted.',
  leaveWorkspaceConfirm:
    'Are you sure you want to leave this workspace? Your data in this workspace will be deleted.',
  generalTab: 'General',
  membersTab: 'Members',
  docsTab: 'Docs',
  rulesTab: 'Rules',
  rulesTitle: 'Workspace rules',
  rulesDescription: 'Rules agents follow across every chat in this workspace.',
  rulesAdd: 'Add rule',
  rulesCreateLabel: 'New rule text',
  rulesCreated: 'Workspace rule added.',
  rulesLoading: 'Loading workspace rules…',
  rulesLoadFailed: 'Workspace rules could not be loaded.',
  rulesRetry: 'Try again',
  rulesEmptyTitle: 'No workspace rules yet',
  rulesEmptyDescription:
    'Add a rule here or explain a durable team process in chat.',
  rulesUpdatedAt: 'Updated {{date}}',
  rulesEdit: 'Edit rule',
  rulesEditLabel: 'Rule text',
  rulesDelete: 'Delete rule',
  rulesCancel: 'Cancel',
  rulesSave: 'Save',
  rulesUpdated: 'Workspace rule updated.',
  rulesDeleted: 'Workspace rule deleted.',
  rulesMutationFailed: 'Could not change the workspace rule.',
  rulesDeleteConfirmTitle: 'Delete workspace rule?',
  rulesDeleteConfirmDescription:
    'The rule will stop applying to future conversations. This action cannot be undone.',
  rulesVersionConflictTitle: 'This rule changed',
  rulesVersionConflictDescription:
    'A newer version was saved by another member. The list has been refreshed.',
  rulesDuplicateTitle: 'Duplicate rule',
  rulesDuplicateDescription:
    'The workspace already contains a rule with the same meaning.',
  rulesConflictTitle: 'Conflicting rule',
  rulesConflictDescription:
    'This wording conflicts with another workspace rule. Review the existing rules first.',
  ownerRole: 'owner',
  memberRole: 'member',
  pleaseTryAgain: 'Please try again.',
  connectorOfflineTitle: 'Integration unavailable',
  connectorOfflineDescription:
    'The connector is offline. Retry after the connection is restored.',
  connectorBackOnlineTitle: 'Connector is back online',
  connectorBackOnlineDescription:
    'You can continue. Resending your last request…',
  jiraSettingsAuthNote:
    'Workspace admin authenticates once through Atlassian OAuth. After connection, choose Jira Project from available projects.',
  confluenceSettingsAuthNote:
    'Workspace admin authenticates once through Atlassian OAuth. Everyone in this workspace then uses the shared Confluence connection.',
  jiraSetupInstructions:
    'Create a Jira user named "Laplace" and grant it only the permissions Laplace needs: "Browse projects" and "Add comments". Then start authentication and sign in to Jira with that user.',
  confluenceSetupInstructions:
    'Connect an Atlassian account with access to the needed Confluence spaces. Everyone in this workspace can then ask questions about available pages.',
  jiraStatusNotConnected: 'Not connected',
  confluenceStatusNotConnected: 'Not connected',
  githubStatusNotConnected: 'Not connected',
  jiraStatusDisabled: 'Disabled',
  confluenceStatusDisabled: 'Disabled',
  githubStatusDisabled: 'Disabled',
  jiraStatusConnected: 'Connected',
  jiraStatusReconnectRequired: 'Reconnect required',
  confluenceStatusConnected: 'Connected',
  confluenceStatusReconnectRequired: 'Reconnect required',
  gmailStatusNotConnected: 'Not connected',
  gmailStatusDisabled: 'Disabled',
  gmailStatusConnected: 'Connected',
  gmailStatusReconnectRequired: 'Reconnect required',
  gmailSetupInstructions:
    'Connect a shared mailbox for this workspace. Members can create drafts and send messages when explicitly requested.',
  githubStatusConnected: 'Connected',
  githubStatusReconnectRequired: 'Reconnect required',
  githubStatusScopeInvalid: 'Connected — scope needs update',
  loadingJiraConnection: 'Loading Jira connection status...',
  loadingConfluenceConnection: 'Loading Confluence connection status...',
  loadingGitHubConnection: 'Loading GitHub connection status...',
  unableToLoadJiraConnection: 'Unable to load Jira connection status.',
  unableToLoadConfluenceConnection:
    'Unable to load Confluence connection status.',
  unableToLoadGitHubConnection: 'Unable to load GitHub connection status.',
  githubSetupInstructions:
    'Install the GitHub App, choose the account or organization and the repositories on GitHub, then you will be redirected back here.',
  githubAuthentication: 'GitHub App installation',
  githubStatus: 'Status: {{status}}',
  githubInstallApp: 'Install GitHub App',
  githubInstallAnotherApp: 'Install Another GitHub App',
  githubReinstallApp: 'Reconfigure GitHub App',
  githubLinkPickerTitle: 'Choose a GitHub installation',
  githubLinkPickerHint:
    'Pick an account or organization that already has the GitHub App installed. No Configure screen on GitHub.',
  githubLinkPickerExpired:
    'Link session expired. Close and open Install GitHub App again.',
  githubLinkPickerDismiss: 'Dismiss',

  // Plugins tab
  pluginsTab: 'Plugins',
  jiraPluginDescription: 'Create, update and track project issues.',
  confluencePluginDescription: 'Search and answer questions about your pages.',
  gmailPluginDescription: 'Send email from a shared Gmail mailbox.',
  githubPluginDescription:
    'Search and answer questions about issues, pull requests, and repositories.',
  addPlugin: 'Add plugin',
  addPluginTitle: 'Add a plugin',
  addPluginDescription: 'Choose an integration to connect to this workspace.',
  allPluginsAdded: 'All available plugins are already added.',
  pluginSettings: 'Settings',
  pluginStatusConnected: 'Connected',
  pluginStatusNotConnected: 'Not connected',
  pluginStatusDisabled: 'Disabled',
  pluginStatusReconnectRequired: 'Reconnect required',
  pluginsConnectedCount: '{{number}} connected',
  pluginsReadOnlyHint: 'Plugins enabled for this workspace.',

  // Members tab
  searchByNameOrEmail: 'Search by name or email...',
  selectAll: 'Select all',
  clearSelection: 'Clear selection',
  showOnlySelected: 'Show only selected',
  ownerBadge: 'Owner',
  userRole: 'User',
  adminRole: 'Admin',
  noMembersFound: 'No members found.',
  removeMembersConfirmTitle: 'Remove members',
  removeMembersConfirm: 'Are you sure? Data for {{names}} will be deleted.',

  // Docs tab
  docsUploadTitle: 'Drop a document here',
  docsUploadDescription: 'PDF, DOCX, PPTX, XLSX, MD or TXT up to 10 MB.',
  docsChooseFile: 'Choose file',
  docsUploading: 'Uploading...',
  docsUploadSuccessTitle: 'Uploaded: {{count}}',
  docsUploadSuccessDescription: 'Processing has started.',
  docsUploadSkippedTitle: 'Some files were skipped',
  docsUploadSkippedDescription:
    '{{count}} file(s) did not match the supported formats or 10 MB limit.',
  docsUploadFailedTitle: 'Upload failed: {{count}}',
  docsDuplicateTitle: 'Already uploaded',
  docsDuplicateDescription:
    'The same document content already exists in this workspace.',
  docsName: 'Name',
  docsType: 'Type',
  docsUploadedAt: 'Uploaded',
  docsUploadedBy: 'Uploaded by',
  docsDeletedUser: 'Deleted user',
  docsSize: 'Size',
  docsStatus: 'Status',
  docsActions: 'Actions',
  docsOpen: 'Download document',
  docsOpenFailed: 'Unable to download document',
  docsRetryIndexing: 'Try again',
  docsProcessingRestarted: 'Processing restarted',
  docsProcessingRestartedDescription: 'The file will be available soon.',
  docsRetryFailed: 'Unable to restart processing',
  docsReindex: 'Improve with Docling',
  docsReindexAvailableTooltip:
    'Improve structure, tables, and formatting by processing this document with Docling.',
  docsReindexDisabledTooltip:
    'Docling is disabled, so improved processing is unavailable.',
  docsReindexingTooltip: 'Improved processing is in progress.',
  docsReindexStarted: 'Improved processing started',
  docsReindexStartedDescription:
    'The current searchable version remains available during processing.',
  docsReindexFailed: 'Unable to start improved processing',
  docsReindexAlreadyInProgress: 'Improved processing is already in progress.',
  docsFailureNoTextContent: 'No searchable text was found in this document.',
  docsFailureIndexingFailed:
    'The document could not be processed. Please try again.',
  docsFailureDoclingRequiredDisabled:
    'Docling is required to process PPTX and XLSX files, but it is disabled.',
  docsFailureDoclingRequiredUnavailable:
    'Docling is required to process PPTX and XLSX files, but it is currently unavailable. Please try again later.',
  docsFailureDoclingRequiredConversionFailed:
    'Docling could not process this PPTX or XLSX file. Check the file and try again.',
  docsFailureDoclingUpgradeUnavailable:
    'Docling is currently unavailable. The existing searchable version remains available.',
  docsFailureDoclingUpgradeFailed:
    'Docling could not improve this document. The existing searchable version remains available.',
  docsFailureMalformed:
    'This file is damaged: its internal document structure is broken. Enhanced processing is not possible; the existing searchable version remains available. Re-save the file in Word and upload it again.',
  docsLoading: 'Loading documents...',
  docsEmpty: 'No documents uploaded yet.',
  docsDelete: 'Delete document',
  docsDeleteConfirm: 'Are you sure you want to delete "{{name}}"?',
  docsDeleted: 'File deleted',
  docsDeleteFailed: 'Delete failed',
  docsInvalidFormat: 'Unsupported document format',
  docsTooLarge: 'Document is too large',
  docsStatus_pending: 'Processing',
  docsStatus_reindexing: 'Improving',
  docsStatus_indexed: 'Ready',
  docsStatus_failed: 'Error',

  // Notifications
  jiraConnected: 'Jira connected',
  confluenceConnected: 'Confluence connected',
  gmailConnected: 'Gmail connected',
  githubConnected: 'GitHub connected',
  githubOAuthCompleting: 'Completing GitHub authorization',
  githubOAuthReturning: 'Returning to your workspace…',
  jiraDisconnected: 'Jira disconnected',
  confluenceDisconnected: 'Confluence disconnected',
  gmailDisconnected: 'Gmail disconnected',
  gmailAccountDisconnected: 'Gmail account {{email}} disconnected',
  githubDisconnected: 'GitHub disconnected',
  jiraConnectionFailed: 'Jira connection failed',
  confluenceConnectionFailed: 'Confluence connection failed',
  gmailConnectionFailed: 'Gmail connection failed',
  githubConnectionFailed: 'GitHub connection failed',
  gmailConnectionFailedDescription:
    'Unable to connect Gmail. Check the integration configuration and try again.',
  gmailDisconnectFailedDescription:
    'Unable to disconnect Gmail. Please try again.',
  unableToDisconnectJira: 'Unable to disconnect Jira',
  unableToDisconnectConfluence: 'Unable to disconnect Confluence',
  unableToDisconnectGitHub: 'Unable to disconnect GitHub',
  oauthPopupLoadingTitle: 'Loading…',
  oauthPopupLoadingMessage: 'Loading authorization…',
  popupBlocked: 'Popup blocked',
  popupBlockedDescription:
    'Allow popups for Laplace to continue Jira authentication.',
  popupBlockedConfluenceDescription:
    'Allow popups for Laplace to continue Confluence authentication.',
  popupBlockedGmailDescription:
    'Allow popups for Laplace to continue Gmail authentication.',
  yandexMail: 'Yandex Mail',
  enableYandexMailIntegration:
    'Enable shared Yandex Mail integration for this workspace.',
  yandexMailPluginDescription:
    'Search, read, draft and send email from a shared Yandex mailbox.',
  yandexMailStatus: 'Status: {{status}}',
  yandexMailStatusNotConnected: 'Not connected',
  yandexMailStatusDisabled: 'Disabled',
  yandexMailStatusConnected: 'Connected',
  yandexMailStatusReconnectRequired: 'Reconnect required',
  yandexMailSetupInstructions:
    'Connect the shared Yandex Mail account used by this workspace. All workspace members can access it through the agent.',
  authenticateWithYandexMail: 'Authenticate with Yandex Mail',
  reconnectYandexMail: 'Reconnect Yandex Mail',
  connectAnotherYandexMailAccount: 'Connect another Yandex Mail account',
  yandexMailConnected: 'Yandex Mail connected',
  yandexMailDisconnected: 'Yandex Mail disconnected',
  yandexMailAccountDisconnected: 'Yandex Mail account {{email}} disconnected',
  yandexMailConnectionFailedDescription:
    'Unable to connect Yandex Mail. Check OAuth, IMAP and SMTP access and try again.',
  yandexMailDisconnectFailedDescription:
    'Unable to disconnect Yandex Mail. Please try again.',
  popupBlockedYandexMailDescription:
    'Allow popups for Laplace to continue Yandex Mail authentication.',
  calendar: 'Calendar',
  calendarPluginDescription:
    'Connect one shared primary calendar from Google, Yandex or Outlook.',
  googleCalendar: 'Google Calendar',
  googleCalendarPluginDescription:
    'Connect the primary Google Calendar of an administrator.',
  yandexCalendar: 'Yandex Calendar',
  yandexCalendarPluginDescription:
    'Connect the primary Yandex Calendar of an administrator.',
  outlookCalendar: 'Outlook Calendar',
  outlookCalendarPluginDescription:
    'Connect the primary Outlook Calendar of an administrator.',
  calendarWorkspaceSharingWarning:
    'The connected primary calendar becomes available to every member of this workspace through Laplace.',
  calendarProvider: 'Provider',
  calendarSyncState: 'Sync state',
  calendarLastSuccessfulSync: 'Last successful sync',
  calendarReconnectRequired:
    'The calendar requires reconnection or a successful sync.',
  calendarConnectProvider: 'Connect {{provider}}',
  calendarReconnectProvider: 'Reconnect {{provider}}',
  calendarReplaceTitle: 'Replace the shared calendar?',
  calendarReplaceDescription:
    'This will replace {{current}} with {{next}} after the new OAuth connection succeeds. The old calendar remains active until then.',
  calendarConfirmReplace: 'Confirm replacement',
  calendarConnected: 'Calendar connected',
  calendarDisconnected: 'Calendar disconnected',
  calendarConnectionFailed: 'Unable to connect the calendar. Please try again.',
  calendarDisconnectFailed:
    'Unable to disconnect the calendar. Please try again.',
  calendarPopupBlockedDescription:
    'Allow popups for Laplace to continue calendar authentication.',
  telegram: 'Telegram',
  telegramPluginDescription:
    'Answers in linked group chats using your workspace services (read-only).',
  telegramGenerateCode: 'Generate link code',
  telegramCodeInstruction:
    'In the target group (with the bot added), send as an admin: /link {{code}}',
  telegramCodeExpiresAt: 'Code valid until {{time}}',
  telegramLinkedChats: 'Linked chats',
  telegramNoLinkedChats: 'No linked chats yet.',
  telegramTasksEnabled: 'Create and update tasks from chat',
  telegramTasksHint:
    'Members can ask the bot to file a task or add a comment and status to an existing one. Nothing reaches Jira until the person who asked confirms it with a button.',
  telegramTasksUpdateFailed: 'Could not change the setting. Please try again.',
  telegramUnlink: 'Unlink',
  telegramGenerateFailed: 'Could not generate a code. Please try again.',
  telegramUnlinkFailed: 'Could not unlink the chat. Please try again.',
  cancel: 'Cancel',
}
